var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDec2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.983,
    height: 23.983,
    viewBox: "0 0 23.983 23.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#1458a0;stroke-miterlimit:10;stroke-width:3px;opacity:0.29;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.959,
    height: 13.959,
    transform: "translate(11.992 2.121) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDec2);
export default __webpack_public_path__ + "static/media/CardDec2.052f81f793928aac4bfa6e9708f32307.svg";
export { ForwardRef as ReactComponent };